export type StateCalculator<S> = (state: S, previous: S) => S;

export type StateCalculators<S> = StateCalculator<S> | StateCalculator<S>[];

export class StateTools {
  /**
   * Recalculates and updates the state by applying a list of provided functions sequentially.
   */
  public static calculate<S>(current: S, state: S, calcFns: StateCalculators<S>): S {
    // Single calculator
    if (!Array.isArray(calcFns)) {
      calcFns = [calcFns];
    }

    // Array of calculators
    for (const calcFn of calcFns) {
      if (calcFn) {
        state = calcFn(state, current);
      }
    }
    return state;
  }
}
